import React, { useState } from 'react';
import './Gallery.css';
import Header from './Header';
import YearTabs from './YearTabs';
import MediaGrid from './MediaGrid';
import Lightbox from './Lightbox';

const Gallery = ({ mediaByYear, yearDescriptions, loading }) => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [showLightbox, setShowLightbox] = useState(false);

  const years = Object.keys(mediaByYear)
    .sort((a, b) => parseInt(b) - parseInt(a));

  React.useEffect(() => {
    if (years.length > 0 && !selectedYear) {
      setSelectedYear(years[0]);
    }
  }, [years, selectedYear]);

  const handleMediaClick = (media) => {
    setSelectedMedia(media);
    setShowLightbox(true);
  };

  const handleCloseLightbox = () => {
    setShowLightbox(false);
  };

  return (
    <div className="gallery-container">
      <Header />

      {loading ? (
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading your memories...</p>
        </div>
      ) : years.length === 0 ? (
        <div className="empty-state">
          <p>No memories found. 📸</p>
          <p style={{ marginTop: '20px', fontSize: '1rem', color: '#ffb6d9' }}>
            Make sure your folder structure looks like this:
          </p>
          <p style={{ marginTop: '10px', color: '#ffb6d9', fontFamily: 'monospace' }}>
            media/<br />
            ├── 2025/<br />
            │ ├── image1.jpg<br />
            │ └── video1.mp4<br />
            ├── 2024/<br />
            └── 2023/
          </p>
        </div>
      ) : (
        <>
          <YearTabs
            years={years}
            selectedYear={selectedYear}
            mediaByYear={mediaByYear}
            yearDescriptions={yearDescriptions}
            onSelectYear={setSelectedYear}
          />
          {selectedYear && (
            <>
              {yearDescriptions[selectedYear] && (
                <div className="year-description">
                  <p>{yearDescriptions[selectedYear]}</p>
                </div>
              )}
              <MediaGrid
                media={mediaByYear[selectedYear]}
                onMediaClick={handleMediaClick}
              />
            </>
          )}
        </>
      )}

      {showLightbox && selectedMedia && (
        <Lightbox media={selectedMedia} onClose={handleCloseLightbox} />
      )}
    </div>
  );
};

export default Gallery;